export default "__VITE_ASSET__C0DlMw1R__"